import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, X } from 'lucide-react';
const NAMES = ['Martín', 'Sofía', 'Lucía', 'Federico', 'Camila', 'Joaquín', 'Agustina', 'Mateo', 'Julieta', 'Nicolás', 'Florencia', 'Tomás', 'Valentina', 'Santiago', 'Micaela', 'Bruno', 'Brenda', 'Diego', 'Carolina', 'Emilia', 'Franco', 'Rocío', 'Gonzalo', 'Antonella'];
const LAST_INITIALS = ['G.', 'M.', 'R.', 'F.', 'P.', 'S.', 'L.', 'C.', 'B.', 'D.', 'A.', 'V.'];
const CITIES = ['Buenos Aires', 'Rosario', 'Córdoba', 'La Plata', 'Mendoza', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Bahía Blanca', 'Posadas', 'Paraná', 'Corrientes', 'San Luis', 'San Rafael', 'Tandil', 'Río Cuarto'];
const OFFERS = ['El Sistema Completo', 'Sistema + 6 Bonos Estratégicos'];
const TIME_AGO = ['hace 2 minutos', 'hace 4 minutos', 'hace 6 minutos', 'hace 9 minutos', 'hace 12 minutos', 'hace 17 minutos', 'hace 23 minutos'];
function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
interface Notification {
  id: number;
  name: string;
  city: string;
  offer: string;
  timeAgo: string;
}
function buildNotification(id: number): Notification {
  return {
    id,
    name: `${pick(NAMES)} ${pick(LAST_INITIALS)}`,
    city: pick(CITIES),
    offer: pick(OFFERS),
    timeAgo: pick(TIME_AGO)
  };
}
export function PurchaseNotification() {
  const [current, setCurrent] = useState<Notification | null>(null);
  useEffect(() => {
    let visibleTimer: ReturnType<typeof setTimeout>;
    let nextTimer: ReturnType<typeof setTimeout>;
    let id = 0;
    const showNext = () => {
      id += 1;
      setCurrent(buildNotification(id));
      // Hide after 6s
      visibleTimer = setTimeout(() => {
        setCurrent(null);
        // Wait 40–60s before next
        const wait = 40000 + Math.random() * 20000;
        nextTimer = setTimeout(showNext, wait);
      }, 6000);
    };
    // First popup after a short delay so the user sees the page first
    nextTimer = setTimeout(showNext, 8000);
    return () => {
      clearTimeout(visibleTimer);
      clearTimeout(nextTimer);
    };
  }, []);
  const handleDismiss = () => setCurrent(null);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-122">
      <AnimatePresence data-id="element-123">
        {current && <motion.div key={current.id} initial={{
        opacity: 0,
        y: 24,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.97
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto w-[320px] max-w-[calc(100vw-2rem)] bg-bone border border-ink/15 rounded-sm shadow-lg overflow-hidden" role="status" aria-live="polite" data-id="element-124">
            <div className="flex items-start gap-3 p-4" data-id="element-125">
              <div className="shrink-0 w-10 h-10 rounded-full bg-sage/20 flex items-center justify-center" data-id="element-126">
                <ShieldCheck size={20} className="text-sage" strokeWidth={2.2} data-id="element-127" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-128">
                <div className="flex items-center gap-2 mb-1" data-id="element-129">
                  <span className="text-[10px] font-sans font-semibold tracking-widest uppercase text-sage" data-id="element-130">
                    Compra verificada
                  </span>
                </div>
                <p className="font-sans text-sm text-ink leading-snug" data-id="element-131">
                  <strong className="font-semibold" data-id="element-132">{current.name}</strong> de{' '}
                  <span className="text-ink" data-id="element-133">{current.city}</span> compró{' '}
                  <span className="font-medium" data-id="element-134">{current.offer}</span>.
                </p>
                <p className="font-sans text-xs text-ink-light mt-1.5" data-id="element-135">
                  {current.timeAgo}
                </p>
              </div>
              <button onClick={handleDismiss} aria-label="Cerrar notificación" className="shrink-0 text-ink/40 hover:text-ink transition-colors" data-id="element-136">
                <X size={16} data-id="element-137" />
              </button>
            </div>
            {/* progress bar to show auto-dismiss */}
            <motion.div className="h-0.5 bg-oxblood/60 origin-left" initial={{
          scaleX: 1
        }} animate={{
          scaleX: 0
        }} transition={{
          duration: 6,
          ease: 'linear'
        }} data-id="element-138" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}